import { ApplicationState } from "store";
import {
    DefaultCulture,
    LOCAL_STORAGE_RELOAD_CALENDAR_A5,
    LOCAL_STORAGE_RELOAD_CALENDAR_A6,
    LOCAL_STORAGE_RELOAD_CALENDAR_B5,
    LOCAL_STORAGE_RELOAD_NOTEBOOK_A5,
    LOCAL_STORAGE_RELOAD_NOTEBOOK_A6,
    LOCAL_STORAGE_RELOAD_NOTEBOOK_B5,
} from "ui/constants";
import { CalendarSizes, CalendarType } from "svg/constants";
import { CalendarState, PostData } from "burde";

export const getCultureFromInitialState = (
    initialState: ApplicationState | undefined,
) => {
    return initialState !== undefined &&
        initialState.calendar &&
        initialState.calendar.culture !== null
        ? initialState.calendar.culture
        : DefaultCulture;
};

export const getIsLocalStorageSet = (
    calendarSize: string,
    calendarType: string,
) => {
    if (calendarSize === CalendarSizes.A5.toLowerCase()) {
        if (calendarType === CalendarType.Calendar) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_CALENDAR_A5);
        } else if (calendarType === CalendarType.Notebook) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_NOTEBOOK_A5);
        }
    } else if (calendarSize === CalendarSizes.A6) {
        if (calendarType === CalendarType.Calendar) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_CALENDAR_A6);
        } else if (calendarType === CalendarType.Notebook) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_NOTEBOOK_A6);
        }
    } else if (calendarSize === CalendarSizes.B5) {
        if (calendarType === CalendarType.Calendar) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_CALENDAR_B5);
        } else if (calendarType === CalendarType.Notebook) {
            return localStorage.getItem(LOCAL_STORAGE_RELOAD_NOTEBOOK_B5);
        }
    }
};
